import { useLayoutEffect } from 'react'
import GraphitLoader from '@/components/brand/GraphitLoader'
import { holdBootLoader } from '@/boot'

/**
 * The full-area loading state for route transitions, the auth check and
 * other page-level waits: the animated Graphit mark and one line of text. It
 * stays invisible for the first 300 ms, so quick loads show nothing at all.
 * The boot preloader in index.html draws the same mark before the app loads.
 */
export default function PageLoader({ label = 'Loading…' }) {
  // While the boot preloader is still up, keep it up rather than swap to this.
  useLayoutEffect(() => holdBootLoader(), [])
  return (
    <div className="gl-delayed flex min-h-[60dvh] flex-col items-center justify-center gap-4 px-6 text-body text-ink-2">
      <GraphitLoader size={56} label={label} />
      <span aria-hidden="true">{label}</span>
    </div>
  )
}
